<template>
  <div class="site-panel__help">
    Click on a feature on the map to load the feature's data into this panel.
  </div>
</template>
<script>
  export default {

  }
</script>